import type { CurationToolRuleType } from '@empathyco/playboard-core-domain'
import type { RelatedTagPositionEnum } from '../../enums'

export interface RelatedTagConfig {
  tag: string
  tagPosition: RelatedTagPositionEnum
  rule?: {
    id?: number
    type: CurationToolRuleType
  }
  validityState?: ValidityState
  draggable?: boolean
}

export interface ValidityState {
  type: ValidityStateTypeEnum
  message?: string
}

export enum ValidityStateTypeEnum {
  VALID = 'valid',
  ERROR = 'error',
  WARNING = 'warning',
}
